.modalContent {
  background-color: white;
  border-radius: 4px;
  max-height: 90%;
  max-width: 100%;
  overflow-y: auto;
  padding: 10px 0;
}

.presets {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0 10% 1rem;
}

.presetsTitle {
  font-weight: 600;
  margin-right: 0.25rem;
  width: 100%;
}

.preset {
  align-items: center;
  background: #ffffff;
  border: 1px solid var(--color-text-muted);
  border-radius: 999px;
  color: var(--color-text);
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  gap: 0.5rem;
  min-height: 44px;
  padding: 0.25rem 0.75rem 0.25rem 0.25rem;
}

.preset[aria-pressed="true"] {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px var(--color-primary);
}

.preset:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.presetSwatch {
  align-items: center;
  border: 3px solid;
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 700;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.colorField {
  display: inline-block;
  width: 20%;
  margin: 0;
  padding: 0;
}

.colorFieldOffset {
  margin-left: 10%;
}

.colorInput {
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border-radius: 10px;
}

.downloadLink {
  display: inline-block;
  width: 20%;
}

.previewCanvas {
  background-color: var(--screenshot-canvas);
  border: 1px dashed var(--color-primary);
  color: var(--screenshot-fg);
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 20px;
}

@media (max-width: 640px) {
  .colorField,
  .downloadLink {
    display: block;
    margin-left: 0;
    width: 100%;
  }

  .colorFieldOffset {
    margin-left: 0;
  }

  .presets {
    margin: 0 0.5rem 1rem;
  }

  .previewCanvas {
    padding: 1rem 0.5rem;
  }
}
